module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/assessment_achievements/3_b88368a894877299d246478fff39690b.png";